export default "__VITE_ASSET__46460559__"